import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpApi from "i18next-http-backend";

// 🔹 nova chave de idioma (não conflita com a antiga "lang")
const LANG_KEY = "lang_ssa";

// 🔹 idioma salvo ou padrão
const savedLang = localStorage.getItem(LANG_KEY) || "pt";

i18n
  .use(HttpApi)
  .use(initReactI18next)
  .init({
    supportedLngs: ["pt", "en"],
    fallbackLng: "pt",
    lng: savedLang,
    backend: {
      loadPath: process.env.PUBLIC_URL + "/locales/{{lng}}/translation.json",
    },
    interpolation: {
      escapeValue: false,
    },
  });

// 🔹 sincroniza idioma do HTML com o i18n
const syncHtmlLang = (lng) => {
  document.documentElement.lang = lng === "pt" ? "pt-BR" : "en-US";
};

// 🔹 aplica no carregamento inicial
syncHtmlLang(savedLang);

// 🔹 aplica sempre que trocar idioma
i18n.on("languageChanged", (lng) => {
  localStorage.setItem(LANG_KEY, lng);
  syncHtmlLang(lng);
});

export default i18n;
